import { render, staticRenderFns } from "./TeaCaseWeb.vue?vue&type=template&id=89868174&scoped=true&"
import script from "./TeaCaseWeb.vue?vue&type=script&lang=js&"
export * from "./TeaCaseWeb.vue?vue&type=script&lang=js&"
import style0 from "./TeaCaseWeb.vue?vue&type=style&index=0&id=89868174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89868174",
  null
  
)

export default component.exports